export const getYear = state => state.reportCustomerResults.getIn(['list', 'year'])
export const getData = state => state.reportCustomerResults.getIn(['list', 'data'])
export const getFetching = state => state.reportCustomerResults.getIn(['list', 'fetching'])
export const getError = state => state.reportCustomerResults.getIn(['list', 'error'])

export const getDetailsData = state => state.reportCustomerResults.getIn(['details', 'data'])
export const getDetailsFetching = state => state.reportCustomerResults.getIn(['details', 'fetching'])
export const getDetailsError = state => state.reportCustomerResults.getIn(['details', 'error'])
